import { z } from 'zod';
import { dataAppVizGradientValueSchema } from './types';
const previewValueSchema = z.union([z.string(), z.number(), z.boolean()]);
export const dataAppVizPreviewSchema = z.object({
    rows: z
        .array(z.record(z.string(), previewValueSchema.nullable()))
        .min(1)
        .max(1000)
        .optional(),
    optionValues: z
        .record(z.string(), z.union([previewValueSchema, dataAppVizGradientValueSchema]))
        .optional(),
});
export const getDataAppVizPreviewSchema = (schema) => dataAppVizPreviewSchema.superRefine((preview, ctx) => {
    const fieldNames = new Set(schema.fields.map((field) => field.name));
    preview.rows?.forEach((row, index) => {
        Object.keys(row).forEach((name) => {
            if (!fieldNames.has(name)) {
                ctx.addIssue({
                    code: 'custom',
                    path: ['rows', index, name],
                    message: 'Unknown preview field',
                });
            }
        });
        schema.fields.forEach((field) => {
            if (field.required && !Object.hasOwn(row, field.name)) {
                ctx.addIssue({
                    code: 'custom',
                    path: ['rows', index, field.name],
                    message: 'Missing required preview field',
                });
            }
        });
    });
    Object.entries(preview.optionValues ?? {}).forEach(([name, value]) => {
        const option = schema.configOptions.find((item) => item.name === name);
        let valid = false;
        if (option?.type === 'gradient') {
            valid = dataAppVizGradientValueSchema.safeParse(value).success;
        }
        else if (option?.type === 'select') {
            valid = option.choices.some((choice) => choice.value === value);
        }
        else if (option) {
            valid =
                typeof value ===
                    (option.type === 'color' || option.type === 'text'
                        ? 'string'
                        : option.type);
        }
        if (!valid) {
            ctx.addIssue({
                code: 'custom',
                path: ['optionValues', name],
                message: 'Unknown preview option or invalid value',
            });
        }
    });
});
//# sourceMappingURL=preview.js.map